import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { BackStackProvider } from '@wildidea/components/hooks/useBackStack';
import { DeviceLocationProvider } from '@wildidea/components/hooks/useDeviceLocation';
import { Toaster } from '@wildidea/components/Toaster/Toaster';

import RescueAllyTheme from '@theme/index.js';

import { captureAcquisitionParams } from './acquisition.js';
import { App } from './App.js';

// Capture utm/click params from ad landings before anything renders — the
// store CTAs re-attach them (see acquisition.ts).
captureAcquisitionParams();

const AppStack = (
  <React.StrictMode>
    <BrowserRouter>
      <BackStackProvider>
        <DeviceLocationProvider>
          <RescueAllyTheme>
            <Toaster defaultDismissTimeout={10000}>
              <App />
            </Toaster>
          </RescueAllyTheme>
        </DeviceLocationProvider>
      </BackStackProvider>
    </BrowserRouter>
  </React.StrictMode>
);

const rootEl = document.getElementById('root')!;
// react-static-prerender captures HTML via Puppeteer (browser DOM serialization),
// not ReactDOMServer.renderToString(), so the prerendered HTML lacks React's
// hydration markers. Always use createRoot to avoid hydration mismatch errors.
rootEl.textContent = '';
createRoot(rootEl).render(AppStack);
